import React, { useEffect } from 'react'

import {Slide, ToastContainer} from 'react-toastify';
import { flashMessage } from '../../lib/flash'

export default function FlashMessages() {
  useEffect(() => {
    const messages = JSON.parse(localStorage.getItem("flash_messages"));
    if (messages) {
      messages.map((message) => {
        flashMessage(message)
      });
    }

    localStorage.setItem("flash_messages", null);
  }, []);

  return (
    <ToastContainer
      position={"bottom-right"}
      autoClose={1000}
      hideProgressBar={false}
      closeOnClick={false}
      pauseOnHove={true}
      draggabl={true}
      progress={undefined}
      theme={"light"}
      transition={Slide}
    />
  )
}
